module.exports = __webpack_public_path__ + "static/media/index.2dc5f250.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/button/style/index.less
// module id = 931
// module chunks = 0